module.exports = __webpack_public_path__ + "static/media/55_000072.f8e05544.jpg";